export default __webpack_public_path__ + "static/media/hht2_direction_word_play_01.878feb79.png";